import {
  InputGroupCode,
  MachineryInputCode,
  SeedInputCode,
  ToolInputCode,
} from './unit.types';

export const DefaultSingleValueConfig: Record<
  InputGroupCode,
  Record<number, string>
> = {
  [InputGroupCode.SEED]: {
    [SeedInputCode.SEEDLING]: 'trunk',
    [SeedInputCode.CUTTING_GRAFT]: 'number',
  },

  [InputGroupCode.MACHINERY]: {
    [MachineryInputCode.DEFAULT]: 'device',
  },

  [InputGroupCode.TOOL]: {
    [ToolInputCode.TIE_STRAPS]: 'device',
    [ToolInputCode.GENERAL_TOOLS]: 'number',
    [ToolInputCode.PRUNING_TOOLS]: 'number',
    [ToolInputCode.WATER_EQUIPMENT]: 'number',
    [ToolInputCode.GROWING_MEDIA]: 'number',
    [ToolInputCode.GREENHOUSE]: 'number',
    [ToolInputCode.LIVESTOCK_FARMING]: 'number',
  },

  // input groups with NO default → empty object
  [InputGroupCode.EMPLOYEE]: {},
  [InputGroupCode.LAB]: {},
  [InputGroupCode.FARM]: {},
  [InputGroupCode.FERTILIZER]: {},
  [InputGroupCode.PESTICIDE]: {},
};
